import {
  TOOL_PARTNER_PRODUCT_PROMOTION, TOOL_CUSTOMER_FILE_CATEGORIES,
  TOOL_CUSTOMER_ARTWORK, TOOL_CUSTOMER_FILE,
  TOOL_CUSTOMER_ARTWORK_CATEGORIES,
} from '../actions/types';

const initialState = {
  productPromotions: [],
  toolCustomerArtworks: [],
  toolArtworkCategories:[],
};

const partnerReducer = (state = initialState, action) => {
  switch(action.type) {
    
    case TOOL_PARTNER_PRODUCT_PROMOTION:
      return { ...state, productPromotions: action.payload };

    case TOOL_CUSTOMER_ARTWORK:
      return { ...state, toolCustomerArtworks: action.payload };

    case TOOL_CUSTOMER_ARTWORK_CATEGORIES:
      return { ...state, toolArtworkCategories: action.payload };
    
    case TOOL_CUSTOMER_FILE_CATEGORIES:
      return { ...state, toolFileCategories: action.payload };

    case TOOL_CUSTOMER_FILE:
      return { ...state, toolCustomerfiles: action.payload };

    default:
      return state;
  }
};

export default partnerReducer;